import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.tsx';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, token, isInitialized, user, showTokenExpiredModal } = useAuth();

  // Auth henüz initialize olmadıysa loading göster
  if (!isInitialized) {
    return <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Yükleniyor...</p>
      </div>
    </div>;
  }

  // Token expire modal gösteriliyorsa sayfayı göster (modal zaten gösterilecek)
  if (showTokenExpiredModal && user) {
    return <>{children}</>;
  }

  // Token yoksa veya kullanıcı hotel_admin değilse login'e yönlendir
  if (!isAuthenticated || !token || !user || user.role !== 'hotel_admin') {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
